<div class="modal-header no-icon">
    <h4 class="modal-title pull-left">{{ title }}</h4>
    <button type="button" class="close pull-right" (click)="hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <formly-form
            [form]="form"
            [fields]="fields"
            [model]="model"
            [options]="options"
        ></formly-form>
    </form>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-primary"
        (click)="onSubmit()"
        [disabled]="working || form.invalid"
    >
        Save
    </button>
</div>
